import { builtInViews } from "@hq/core";
import { cn } from "@z/ui";
import { Inbox } from "lucide-react";
import { QuickAdd } from "../QuickAdd";
import { TaskList } from "../TaskList";
import { ViewHeader } from "../ViewHeader";
import { type ViewProps, viewClassName } from "./shared";
import { useViewState } from "./useViewState";

export function InboxView({ onOpenTask, now, className }: ViewProps) {
  const s = useViewState(builtInViews.inbox);
  return (
    <div data-slot="inbox-view" className={cn(viewClassName, className)}>
      <ViewHeader
        mode={s.mode}
        onModeChange={s.setMode}
        title={
          <span className="inline-flex items-center gap-2">
            <Inbox className="size-4 text-fg-muted" />
            Inbox
          </span>
        }
        sort={s.sort}
        onSortChange={s.setSort}
        tags={s.tags}
        onTagsChange={s.setTags}
        availableTags={s.hasTasks ? s.allTags : []}
        displayControls={s.hasTasks && s.mode === "list"}
        groupBy={s.groupBy}
        onGroupByChange={s.setGroupBy}
        showCompleted={s.showCompleted}
        onShowCompletedChange={s.setShowCompleted}
      />
      <TaskList
        view={s.view}
        mode={s.mode}
        onTagClick={s.toggleTag}
        quickAdd={<QuickAdd {...(now ? { now } : {})} />}
        emptyTitle="Inbox is empty"
        emptyDescription="Capture anything here, then sort it into a project or give it a date."
        {...(onOpenTask ? { onOpenTask } : {})}
        {...(now ? { now } : {})}
      />
    </div>
  );
}
